export default "__VITE_ASSET__CPXslm8Z__"